var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54 8.54a.65.65 0 0 1 .92 0L12 14.08l5.54-5.54a.65.65 0 1 1 .92.92l-6 6a.65.65 0 0 1-.92 0l-6-6a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjU0MDM5IDguNTQwMzhDNS43OTQyMyA4LjI4NjU0IDYuMjA1NzggOC4yODY1NCA2LjQ1OTYzIDguNTQwMzhMMTIgMTQuMDgwOEwxNy41NDA0IDguNTQwMzhDMTcuNzk0MiA4LjI4NjU0IDE4LjIwNTggOC4yODY1NCAxOC40NTk2IDguNTQwMzhDMTguNzEzNSA4Ljc5NDIyIDE4LjcxMzUgOS4yMDU3OCAxOC40NTk2IDkuNDU5NjJMMTIuNDU5NiAxNS40NTk2QzEyLjIwNTggMTUuNzEzNSAxMS43OTQyIDE1LjcxMzUgMTEuNTQwNCAxNS40NTk2TDUuNTQwMzkgOS40NTk2MkM1LjI4NjU1IDkuMjA1NzggNS4yODY1NSA4Ljc5NDIyIDUuNTQwMzkgOC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";